import "./App.css";

import { Toaster } from "react-hot-toast";

import RouteComponent from "./RouteComponent";
import ScrollToTop from "./scrolltotop";

function App() {
  return (
    <>
      <Toaster position="top-right" containerStyle={{ zIndex: 12001 }} />
      <ScrollToTop />
      <RouteComponent />
    </>
  );
}

export default App;
